import { useContext } from 'react';
import { CanvasContext } from '../contexts/CanvasContext';

export const useCanvasContext = () => {
	return useContext(CanvasContext);
};
